import React, { useEffect, useState, useCallback, useMemo } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";

import Input from "antd/es/input/Input";
import DeleteConfirmationModal from "../../../../src/components/Modal/DeleteConfirmation";
import { Link, Navigate, useNavigate } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { CCollapse, CLink } from "@coreui/react";
import {
  Dashboard,
  settings,
  Product,
  Users1,
  Vehicle,
  Wrench,
  calendar,
  Employee,
  Suppliers,
  Home,
  Sales1,
  GiftCard,
  Email,
  Receiving,
  Expense,
  Places,
} from "../../../common/imagePath";
import { checkUserPermission } from "../../../common/UserPermission";
import loadingimage from "../../../assets/img/loading-svg.svg";
const ReportList = (props) => {
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("Token");
  const [report, setReport] = useState(0);
  const [cursor, setcursor] = useState(0);
  const [inputValue, setInputValue] = useState("");
  const [ShowLoading, setShowLoading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    // Fetch data from an API
    const fetchData = async () => {
      if (inputValue != "") {
        axios
          .get(
            `${config.reportsBaseUrl}/reports/Findreport?inputvalue=${inputValue}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            }
          )
          .then((response) => {
            if (response != "" && response != null) {
              const data = response.data.ResponseData;
              setSuggestions(data);
              setShowLoading(false);

              // setSuggestions([]);
            }
          })
          .catch((error) => {});
      } else {
        setSuggestions([]);
      }
    };

    fetchData();
  }, [inputValue]);

  const handleInputChange = (event) => {
    const value = event.target.value;
    setShowLoading(true);
    setInputValue(value);

    if (!value) {
      setSuggestions([]);
    }
  };

  return (
    <>
      <Sidebar />

      <Loader loading={loading} />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          {/* Page Header */}
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <div className="col"> */}
              {/* <h3 className="page-title">Reports</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">Reports</li>
              </ul>
              {/* </div> */}
            </div>
          </div>

          {/* Company Information */}
          {/* <div ref={CompanyInformationRef}>
            <CompanyInformation visibleInformationChange={companyInformation} />
          </div> */}

          <div className="row">
            <div className="col-md-6">
              <div className="card">
                <div className="card-body">
                  <div class="list-group col-md-12">
                    {checkUserPermission("/expense-report") ? (
                      <div
                        class={` p-lg list-group-item ${
                          report == 1 ? "active" : ""
                        }`}
                        onClick={() => setReport(1)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fa fa-briefcase mr-2"
                          style={{ color: report == 1 ? "white" : "" }}
                        ></i>{" "}
                        {/* Expense Report */}
                        Business overview
                      </div>
                    ) : (
                      ""
                    )}

                    {checkUserPermission("/invoices-and-received-payments") ? (
                      <div
                        class={`  p-lg list-group-item ${
                          report == 2 ? "active" : ""
                        }`}
                        onClick={() => setReport(2)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fa fa-dollar mr-2"
                          style={{ color: report == 2 ? "white" : "" }}
                        ></i>
                        {/* Invoices and Received Payments */}
                        Who owes you
                      </div>
                    ) : (
                      ""
                    )}
                    {checkUserPermission("/customer-balance-summary") ||
                    checkUserPermission("/customer-balance-detail") ? (
                      <div
                        class={`  p-lg list-group-item ${
                          report == 3 ? "active" : ""
                        }`}
                        onClick={() => setReport(3)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fas fa-user-circle mr-2"
                          style={{ color: report == 3 ? "white" : "" }}
                        ></i>
                        Sales and customers
                      </div>
                    ) : (
                      ""
                    )}
                    {checkUserPermission("/open-invoices") ? (
                      <div
                        class={`  p-lg list-group-item ${
                          report == 4 ? "active" : ""
                        }`}
                        onClick={() => setReport(4)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fas fa-donate mr-2"
                          style={{ color: report == 4 ? "white" : "" }}
                        ></i>
                        {/* Open Invoices */}
                        What you owe
                      </div>
                    ) : (
                      ""
                    )}
                    {checkUserPermission("/customer-contact-list") ||
                    checkUserPermission("/vendor-contact-list") ||
                    checkUserPermission("/employee-contact-list") ? (
                      <div
                        class={`  p-lg list-group-item ${
                          report == 5 ? "active" : ""
                        }`}
                        onClick={() => setReport(5)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fas fa-wallet mr-2"
                          style={{ color: report == 5 ? "white" : "" }}
                        ></i>
                        {/* Contact List */}
                        Expenses and vendors
                      </div>
                    ) : (
                      ""
                    )}
                    {checkUserPermission("/sales-by-customer-detail") ||
                    checkUserPermission("/sales-by-customer-type-detail") ||
                    checkUserPermission("/sales-by-product-service-detail") ? (
                      <div
                        class={`  p-lg list-group-item ${
                          report == 6 ? "active" : ""
                        }`}
                        onClick={() => setReport(6)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fa fa-user mr-2"
                          style={{ color: report == 6 ? "white" : "" }}
                        ></i>
                        {/* Sales */}
                        Employees
                      </div>
                    ) : (
                      ""
                    )}
                    {/* {checkUserPermission('/sales-by-customer-type-detail') ? ( 
                    <div class={`  p-lg list-group-item ${report==7 ? "active" : ""}`}  onClick={()=>setReport(7)} style={{cursor: "pointer"}}>
                      <i class="fa fa-user mr-2"  style={{color: report==7 ? "white":""}}></i> Sales by Customer Type Detail
                    </div>):""}
                    {checkUserPermission('/sales-by-product-service-detail') ? (
                    <div class={`  p-lg list-group-item ${report==8 ? "active" : ""}`}  onClick={()=>setReport(8)} style={{cursor: "pointer"}}>
                      <i class="fa fa-user mr-2" style={{color: report==8 ? "white":""}}></i>Sales by Product/Service
                      Detail
                    </div>):""} */}
                    {checkUserPermission("/transaction-list-by-customer") ||
                    checkUserPermission("/transaction-list-by-vendor") ||
                    checkUserPermission("/transaction-list-by-date") ? (
                      <div
                        class={`  p-lg list-group-item ${
                          report == 9 ? "active" : ""
                        }`}
                        onClick={() => setReport(9)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fas fa-chart-line mr-2"
                          style={{ color: report == 9 ? "white" : "" }}
                          aria-hidden="true"
                        ></i>{" "}
                        For my accountant
                      </div>
                    ) : (
                      ""
                    )}
                    {/* {checkUserPermission(
                      "/sales-by-customer-summary-report"
                    ) ? (
                      <div
                        class={`  p-lg list-group-item ${
                          report == 10 ? "active" : ""
                        }`}
                        onClick={() => setReport(10)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fa fa-search mr-2"
                          style={{ color: report == 10 ? "white" : "" }}
                        ></i>
                        Sales by Customer Summary
                      </div>
                    ) : (
                      ""
                    )} */}
                    {checkUserPermission("/vendor-balance-detail") ||
                    checkUserPermission("/vendor-balance-summary") ? (
                      <div
                        class={`  p-lg list-group-item ${
                          report == 11 ? "active" : ""
                        }`}
                        onClick={() => setReport(11)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fa fa-credit-card mr-2"
                          style={{ color: report == 11 ? "white" : "" }}
                        ></i>
                        {/* Vendor Balance */}
                        Payroll
                      </div>
                    ) : (
                      ""
                    )}
                    {checkUserPermission("") ? (
                      <div
                        class={`  p-lg list-group-item ${
                          report == 12 ? "active" : ""
                        }`}
                        onClick={() => setReport(12)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fas fa-box-open mr-1"
                          style={{
                            color: report == 12 ? "white" : "",
                            fontSize: "16px",
                          }}
                        ></i>
                        {/* Vendor Balance */}
                        Inventory
                      </div>
                    ) : (
                      ""
                    )}

                    {/* {checkUserPermission("/expenses-by-vendor-summary") ? (
                      <div
                        class={`  p-lg list-group-item ${
                          report == 12 ? "active" : ""
                        }`}
                        onClick={() => setReport(12)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fa fa-search mr-2"
                          style={{ color: report == 12 ? "white" : "" }}
                        ></i>
                        Expenses by Vendor Summary
                      </div>
                    ) : (
                      ""
                    )} */}
                    {/* {checkUserPermission("/open-purchase-order-list") ||
                    checkUserPermission("/open-purchase-order-detail") ? (
                      <div
                        class={`  p-lg list-group-item ${
                          report == 13 ? "active" : ""
                        }`}
                        onClick={() => setReport(13)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fa fa-search mr-2"
                          style={{ color: report == 13 ? "white" : "" }}
                        ></i>
                        Open Purchase Order List
                      </div>
                    ) : (
                      ""
                    )} */}
                    {/* {checkUserPermission("/income-by-customer-summery") ? (
                      <div
                        class={`  p-lg list-group-item ${
                          report == 14 ? "active" : ""
                        }`}
                        onClick={() => setReport(14)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fa fa-search mr-2"
                          style={{ color: report == 14 ? "white" : "" }}
                        ></i>{" "}
                        Income by Customer Summary
                      </div>
                    ) : (
                      ""
                    )} */}
                    {/* {checkUserPermission(
                      "/sales-by-product-service-summery"
                    ) ? (
                      <div
                        class={`  p-lg list-group-item ${
                          report == 15 ? "active" : ""
                        }`}
                        onClick={() => setReport(15)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fa fa-search mr-2"
                          style={{ color: report == 15 ? "white" : "" }}
                        ></i>
                        Sales by Product/Service Summary
                      </div>
                    ) : (
                      ""
                    )} */}
                    {/* {checkUserPermission("/trial-balance") ? (
                      <div
                        class={`  p-lg list-group-item ${
                          report == 16 ? "active" : ""
                        }`}
                        onClick={() => setReport(16)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fa fa-search mr-2"
                          style={{ color: report == 16 ? "white" : "" }}
                        ></i>
                        Trial Balance
                      </div>
                    ) : (
                      ""
                    )} */}
                    {/* {checkUserPermission("/balance-sheet-summary") ||
                    checkUserPermission("/balance-sheet-detail") ||
                    checkUserPermission("/profit-and-loss-detail") ||
                    checkUserPermission("/accounts-payable-aging-detail") ||
                    checkUserPermission("/accounts-payable-aging-summary") ||
                    checkUserPermission("/bill-payment-list") ||
                    checkUserPermission("/bills-applied-payments") ||
                    checkUserPermission("/unpaid-bills") ||
                    checkUserPermission("/accounts-receivable-aging-summary") ||
                    checkUserPermission("/accounts-receivable-aging-detail") ? (
                      <div
                        class={`  p-lg list-group-item ${
                          report == 17 ? "active" : ""
                        }`}
                        onClick={() => setReport(17)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fa fa-search mr-2"
                          style={{ color: report == 17 ? "white" : "" }}
                        ></i>
                        Accounts
                      </div>
                    ) : (
                      ""
                    )} */}
                    {/* {checkUserPermission('/profit-and-loss-detail') ? (
                    <div class={`  p-lg list-group-item ${report==18 ? "active" : ""}`} onClick={()=>setReport(18)} style={{cursor: "pointer"}}>
                      <i class="fa fa-search mr-2" style={{color: report==18 ? "white":""}}></i>Profit and Loss
                    </div>):""} */}
                    {/* {((checkUserPermission('/accounts-payable-aging-detail') || checkUserPermission('/accounts-payable-aging-summary') || checkUserPermission('/bill-payment-list')) || checkUserPermission('/bills-applied-payments') || checkUserPermission('/unpaid-bills'))? (
                    <div class={`  p-lg list-group-item ${report==19 ? "active" : ""}`} onClick={()=>setReport(19)} style={{cursor: "pointer"}}>
                      <i class="fa fa-search mr-2" style={{color: report==19 ? "white":""}}></i> Accounts Payable
                    </div>):""} */}
                    {/* {(checkUserPermission('/accounts-receivable-aging-summary') || checkUserPermission('/accounts-receivable-aging-detail')) ? (
                    <div class={`  p-lg list-group-item ${report==20 ? "active" : ""}`} onClick={()=>setReport(20)} style={{cursor: "pointer"}}>
                      <i class="fa fa-search mr-2" style={{color: report==20 ? "white":""}} ></i>Accounts Receivable
                    </div>):""} */}
                    {/* {checkUserPermission("/item-profit-ability-by-customer") ? (
                      <div
                        class={`  p-lg list-group-item ${
                          report == 21 ? "active" : ""
                        }`}
                        onClick={() => setReport(21)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fa fa-search mr-2"
                          style={{ color: report == 21 ? "white" : "" }}
                        ></i>
                        Product/Item Profitability by Customer
                      </div>
                    ) : (
                      ""
                    )} */}
                    {/* <div
                      class={`  p-lg list-group-item ${
                        report == 22 ? "active" : ""
                      }`}
                      onClick={() => setReport(22)}
                      style={{ cursor: "pointer" }}
                    >
                      <i
                        class="fa fa-search mr-2"
                        style={{ color: report == 22 ? "white" : "" }}
                      ></i>
                      Categories
                    </div> */}

                    {/* {checkUserPermission("/sale-delivery-list") ? (
                      <div
                        class={`  p-lg list-group-item ${
                          report == 23 ? "active" : ""
                        }`}
                        onClick={() => setReport(23)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fa fa-search mr-2"
                          style={{ color: report == 23 ? "white" : "" }}
                        ></i>
                        Deliveries
                      </div>
                    ) : (
                      ""
                    )} */}

                    {/* {checkUserPermission("/deleted-sales") ? (
                      <div
                        class={`  p-lg list-group-item ${
                          report == 24 ? "active" : ""
                        }`}
                        onClick={() => setReport(24)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fa fa-search mr-2"
                          style={{ color: report == 24 ? "white" : "" }}
                        ></i>
                        Deleted Sales
                      </div>
                    ) : (
                      ""
                    )} */}

                    {/* {checkUserPermission("/Sales-By-Employee") ? (
                      <div
                        class={`  p-lg list-group-item ${
                          report == 25 ? "active" : ""
                        }`}
                        onClick={() => setReport(25)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fa fa-search mr-2"
                          style={{ color: report == 25 ? "white" : "" }}
                        ></i>
                        Employees
                      </div>
                    ) : (
                      ""
                    )} */}

                    {/* {checkUserPermission("/Inventory-Detailed-Report") ? (
                      <div
                        class={`  p-lg list-group-item ${
                          report == 26 ? "active" : ""
                        }`}
                        onClick={() => setReport(26)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fa fa-search mr-2"
                          style={{ color: report == 26 ? "white" : "" }}
                        ></i>
                        Inventory
                      </div>
                    ) : (
                      ""
                    )} */}

                    {/* {checkUserPermission("/Repots-Manufacturer") ? (
                      <div
                        class={`  p-lg list-group-item ${
                          report == 27 ? "active" : ""
                        }`}
                        onClick={() => setReport(27)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fa fa-search mr-2"
                          style={{ color: report == 27 ? "white" : "" }}
                        ></i>
                        Manufacturer
                      </div>
                    ) : (
                      ""
                    )} */}

                    {/* {checkUserPermission("/Price-Rule-Summary-Report") ? (
                      <div
                        class={`  p-lg list-group-item ${
                          report == 28 ? "active" : ""
                        }`}
                        onClick={() => setReport(28)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fa fa-search mr-2"
                          style={{ color: report == 28 ? "white" : "" }}
                        ></i>
                        Price Rules
                      </div>
                    ) : (
                      ""
                    )} */}

                    {/* {checkUserPermission("/Receiving-List-Report") ? (
                      <div
                        class={`  p-lg list-group-item ${
                          report == 29 ? "active" : ""
                        }`}
                        onClick={() => setReport(29)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fa fa-search mr-2"
                          style={{ color: report == 29 ? "white" : "" }}
                        ></i>
                        Receiving
                      </div>
                    ) : (
                      ""
                    )} */}

                    {/* {checkUserPermission("/payment-detail-report") ? (
                      <div
                        class={`  p-lg list-group-item ${
                          report == 30 ? "active" : ""
                        }`}
                        onClick={() => setReport(30)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fa fa-search mr-2"
                          style={{ color: report == 30 ? "white" : "" }}
                        ></i>
                        Receive Payments
                      </div>
                    ) : (
                      ""
                    )} */}

                    {/* {checkUserPermission("/items-summary-report") ? (
                      <div
                        class={`  p-lg list-group-item ${
                          report == 31 ? "active" : ""
                        }`}
                        onClick={() => setReport(31)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fa fa-search mr-2"
                          style={{ color: report == 31 ? "white" : "" }}
                        ></i>
                        Items
                      </div>
                    ) : (
                      ""
                    )} */}

                    {/* {checkUserPermission("/repots-paybill") ? (
                      <div
                        class={`  p-lg list-group-item ${
                          report == 32 ? "active" : ""
                        }`}
                        onClick={() => setReport(32)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fa fa-search mr-2"
                          style={{ color: report == 32 ? "white" : "" }}
                        ></i>
                        PayBill Report
                      </div>
                    ) : (
                      ""
                    )} */}

                    {/* {checkUserPermission("/detailed-customers-report") ? (
                      <div
                        class={`  p-lg list-group-item ${
                          report == 33 ? "active" : ""
                        }`}
                        onClick={() => setReport(33)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fa fa-search mr-2"
                          style={{ color: report == 33 ? "white" : "" }}
                        ></i>
                        Customers
                      </div>
                    ) : (
                      ""
                      )} */}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="card">
                <div className="card-body">
                  <div style={{ margin: "10px", marginBottom: "16px" }}>
                    <div className="input-group">
                      <input
                        type="text"
                        placeholder="Type Report Name"
                        value={inputValue}
                        onChange={handleInputChange}
                        className="form-control form-control-sm border-size-input"
                      />
                      {suggestions.length === 0 && inputValue !== "" && (
                        <div
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "10px",
                          }}
                        >
                          <img
                            src={loadingimage}
                            alt="Loading..."
                            style={{
                              width: "20px",
                              height: "20px",
                              zIndex: "9999",
                            }}
                          />
                        </div>
                      )}
                      <span className="input-group-append"></span>
                    </div>

                    {suggestions.length > 0 ? (
                      <div
                        className="dropdown col-md-12"
                        style={{ position: "relative" }}
                      >
                        <ul
                          className="dropdown-menu show w-100"
                          style={{
                            maxHeight: "400px",
                            overflowY: "auto",
                            padding: "2px 0px",
                          }}
                        >
                          {suggestions?.map((item, index) => (
                            <li
                              key={item.ID}
                              className={
                                cursor === index
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "8px 12px",
                              }}
                            >
                              <a
                                href={item?.URL}
                                className={
                                  cursor === index
                                    ? "dropdown-item active"
                                    : "dropdown-item"
                                }
                                target="_blank"
                                data-name={item.ReportName.toLowerCase()}
                                style={{
                                  textDecoration: "none",
                                  // color: "inherit",
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  fontSize:"12px",
                                    fontWeight:"600",
                                    color:"#111931"
                                }}
                              >
                                <span>{item.ReportName}</span>
                                <span
                                  style={{
                                    // color: "#8c8c8c",
                                    whiteSpace: "nowrap",
                                    paddingLeft: "10px",
                                    fontSize:"12px",
                                    fontWeight:"400",
                                    color:"#111931"
                                  }}
                                >
                                  {item.tag}
                                </span>
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  {report == 0 ? (
                    <>
                      <p className="fw-bold ">
                        <i class="fa fa-angle-double-left mr-2"></i>Make a
                        Selection
                      </p>
                    </>
                  ) : (
                    ""
                  )}
                  {report == 1 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fa fa-briefcase" color="white"></i> Business
                        overview
                      </p>
                      <div class="list-group col-md-12">
                        <a
                          class="list-group-item"
                          href="/expense-report"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i> Audit Log - NA
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          class="list-group-item"
                          href="/expense-report"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i> Balance Sheet
                          Comparison - NA
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          class="list-group-item"
                          href="/balance-sheet-detail"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i> Balance Sheet Detail
                          <span class="float-end">Quickbooks</span>
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          class="list-group-item"
                          href="/balance-sheet-summary"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i> Balance Sheet Summary
                          <span class="float-end">Quickbooks</span>
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          class="list-group-item"
                          href="/expense-report"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i> Balance Sheet - NA
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          class="list-group-item"
                          href="/expense-report"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i> Business Snapshot - NA
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          class="list-group-item"
                          href="/expense-report"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i> Profit and Loss as %
                          of total income - NA
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          class="list-group-item"
                          href="/expense-report"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i> Profit and Loss
                          Comparison - NA
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          class="list-group-item"
                          href="/profit-and-loss-detail"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i> Profit and Loss Detail
                          <span class="float-end">Quickbooks</span>
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          class="list-group-item"
                          href="/expense-report"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i> Profit and Loss
                          year-to-date comparison - NA
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          class="list-group-item"
                          href="/expense-report"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i> Profit and Loss by
                          Customer - NA
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          class="list-group-item"
                          href="/expense-report"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i> Profit and Loss by
                          Month - NA
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          class="list-group-item"
                          href="/expense-report"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i>Profit and Loss by Tag
                          Group - NA
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          class="list-group-item"
                          href="/expense-report"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i> Profit and Loss - NA
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          class="list-group-item"
                          href="/expense-report"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i> Quarterly Profit and
                          Loss Summary - NA
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          class="list-group-item"
                          href="/expense-report"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i> Statement of Cash
                          Flows - NA
                        </a>
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                  {report == 2 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fa fa-dollar mr-2"></i> Who owes you
                      </p>
                      <div class="list-group col-md-12">
                        <a
                          href="/accounts-receivable-aging-detail"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-receipt "></i> Accounts receivable
                          aging detail
                          <span class="float-end">Quickbooks</span>
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          href="/Repots-Manufacturer"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-receipt "></i> Manufacturer Report
                          <span class="float-end">PHPPOS</span>
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          href="/accounts-receivable-aging-summary"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-receipt "></i> Accounts receivable
                          aging summary
                          <span class="float-end">Quickbooks</span>
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          href="/invoices-and-received-payments"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-receipt "></i> Collections Report -
                          NA
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          href="/customer-balance-detail"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-receipt "></i> Customer Balance
                          Detail
                          <span class="float-end">Quickbooks</span>
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          href="/customer-balance-summary"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-receipt "></i> Customer Balance
                          Summary
                          <span class="float-end">Quickbooks</span>
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          href="/invoices-and-received-payments"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-receipt "></i>Invoice List - NA
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          href="/invoices-and-received-payments"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-receipt "></i> Invoices and Received
                          Payments
                          <span class="float-end">Quickbooks</span>
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          href="/open-invoices"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-receipt "></i> Open Invoices
                          <span class="float-end">Quickbooks</span>
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          href="/invoices-and-received-payments"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-receipt "></i> Statement List - NA
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          href="/invoices-and-received-payments"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-receipt "></i> Terms List - NA
                        </a>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  {report == 3 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fas fa-user-circle mr-2"></i> Sales and
                        customers
                      </p>

                      {checkUserPermission("/detailed-customers-report") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/detailed-customers-report"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i> Detailed
                            Customers Report
                            <span class="float-end">PHPPOS</span>
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/sales-by-categories") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/sales-by-categories"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i> Sales By
                            Categories
                            <span class="float-end">PHPPOS</span>
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/sale-delivery-list") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/sale-delivery-list"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i>Sale Delivery
                            List
                            <span class="float-end">PHPPOS</span>
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/deleted-sales-report") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/deleted-sales-report"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i>Deleted Sale's
                            <span class="float-end">PHPPOS</span>
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/Inventory-Summary-Report") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/Inventory-Summary-Report"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i>Inventory
                            Summary Report
                            <span class="float-end">PHPPOS</span>
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/sales-by-customer-type-detail") ? (
                        <div class="list-group col-md-12 ">
                          <a
                            href="/sales-by-customer-type-detail"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i> Sales by
                            Customer Type Detail
                            <span class="float-end">quickbooks</span>
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/Customer-balance-detail") ? (
                        <div class="list-group col-md-12 ">
                          <a
                            href="/customer-balance-detail"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i> Deposit Detail
                            - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/Customer-balance-detail") ? (
                        <div class="list-group col-md-12 ">
                          <a
                            href="/customer-balance-detail"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i> Estimates &
                            Progress Invoicing Summary by Customer - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission(
                        "/item-profit-ability-by-customer"
                      ) ? (
                        <div class="list-group col-md-12 ">
                          <a
                            href="/item-profit-ability-by-customer"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i> Item
                            Profitability By Customer
                            <span class="float-end">Quickbooks</span>
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/Customer-balance-detail") ? (
                        <div class="list-group col-md-12 ">
                          <a
                            href="/customer-balance-detail"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i> Estimates by
                            Customer - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/income-by-customer-summery") ? (
                        <div class="list-group col-md-12 ">
                          <a
                            href="/income-by-customer-summery"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i> Income by
                            Customer Summary
                            <span class="float-end">Quickbooks</span>
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/Customer-balance-detail") ? (
                        <div class="list-group col-md-12 ">
                          <a
                            href="/customer-balance-detail"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i> Inventory
                            Valuation Detail - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/Customer-balance-detail") ? (
                        <div class="list-group col-md-12 ">
                          <a
                            href="/customer-balance-detail"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i> Inventory
                            Valuation Summary - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/Customer-balance-detail") ? (
                        <div class="list-group col-md-12 ">
                          <a
                            href="/customer-balance-detail"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i> Payment Method
                            List - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/Customer-balance-detail") ? (
                        <div class="list-group col-md-12 ">
                          <a
                            href="/customer-balance-detail"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i> Physical
                            Inventory Worksheet - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/Customer-balance-detail") ? (
                        <div class="list-group col-md-12 ">
                          <a
                            href="/customer-balance-detail"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i>{" "}
                            Product/Service List - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/customer-contact-list") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/customer-contact-list"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i> Customer
                            Contact List
                            <span class="float-end">Quickbooks</span>
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/sales-by-customer-detail") ? (
                        <div class="list-group col-md-12 ">
                          <a
                            href="/sales-by-customer-detail"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i> Sales by
                            Customer Detail
                            <span class="float-end">Quickbooks</span>
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission(
                        "/sales-by-customer-summary-report"
                      ) ? (
                        <div class="list-group col-md-12 ">
                          <a
                            href="/sales-by-customer-summary-report"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i> Sales by
                            Customer Summary
                            <span class="float-end">Quickbooks</span>
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/sales-by-customer-type-detail") ? (
                        <div class="list-group col-md-12 ">
                          <a
                            href="/sales-by-customer-type-detail"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i> Sales by
                            Customer Type Detail
                            <span class="float-end">Quickbooks</span>
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission(
                        "/sales-by-product-service-detail"
                      ) ? (
                        <div class="list-group col-md-12 ">
                          <a
                            href="/sales-by-product-service-detail"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i> Sales by
                            Product/Service Detail
                            <span class="float-end">Quickbooks</span>
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission(
                        "/sales-by-product-service-summery"
                      ) ? (
                        <div class="list-group col-md-12 ">
                          <a
                            href="/sales-by-product-service-summery"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i> Sales by
                            Product/Service Summary
                            <span class="float-end">Quickbooks</span>
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/Customer-balance-detail") ? (
                        <div class="list-group col-md-12 ">
                          <a
                            href="/customer-balance-detail"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i> Time
                            Activities by Customer Detail - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/transaction-list-by-customer") ? (
                        <div class="list-group col-md-12 ">
                          <a
                            href="/transaction-list-by-customer"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i> Transaction
                            List by Customer
                            <span class="float-end">Quickbooks</span>
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/Customer-balance-detail") ? (
                        <div class="list-group col-md-12 ">
                          <a
                            href="/customer-balance-detail"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i> Transaction
                            List by Tag Group - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )}
                  {report == 4 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fas fa-donate mr-2"></i> What you owe
                      </p>
                      <div class="list-group col-md-12">
                        <a
                          href="/open-invoices"
                          class="list-group-item "
                          target="_blank"
                        >
                          <i class="fa fa-searc report-icon"></i> 1099
                          Contractor Balance Detail - NA
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          href="/Receiving-List-Report"
                          class="list-group-item "
                          target="_blank"
                        >
                          <i class="fa fa-searc report-icon"></i> Receiving List
                          Report
                          <span class="float-end">PHPPOS</span>
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          href="/repots-paybill"
                          class="list-group-item "
                          target="_blank"
                        >
                          <i class="fa fa-searc report-icon"></i> Pay-Bill
                          Report
                          <span class="float-end">PHPPOS</span>
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          href="/payment-detail-report"
                          class="list-group-item "
                          target="_blank"
                        >
                          <i class="fa fa-searc report-icon"></i> Payment Detail
                          Report
                          <span class="float-end">PHPPOS</span>
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          href="/payment-summary-report"
                          class="list-group-item "
                          target="_blank"
                        >
                          <i class="fa fa-searc report-icon"></i> Payment
                          Summary Report
                          <span class="float-end">PHPPOS</span>
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          href="/customer-summary-report"
                          class="list-group-item "
                          target="_blank"
                        >
                          <i class="fa fa-searc report-icon"></i> Customer
                          Summary Report
                          <span class="float-end">PHPPOS</span>
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          href="/open-invoices"
                          class="list-group-item "
                          target="_blank"
                        >
                          <i class="fa fa-searc report-icon"></i> 1099
                          Contractor Balance Summary - NA
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          href="/accounts-payable-aging-detail"
                          class="list-group-item "
                          target="_blank"
                        >
                          <i class="fa fa-searc report-icon"></i> Accounts
                          payable aging detail
                          <span class="float-end">Quickbooks</span>
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          href="/accounts-payable-aging-summary"
                          class="list-group-item "
                          target="_blank"
                        >
                          <i class="fa fa-searc report-icon"></i> Accounts
                          payable aging summary 
                          <span class="float-end">Quickbooks</span>
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          href="/bill-payment-list"
                          class="list-group-item "
                          target="_blank"
                        >
                          <i class="fa fa-searc report-icon"></i> Bill Payment
                          List
                          <span class="float-end">Quickbooks</span>
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          href="/bills-applied-payments"
                          class="list-group-item "
                          target="_blank"
                        >
                          <i class="fa fa-searc report-icon"></i> Bills and
                          Applied Payments
                          <span class="float-end">Quickbooks</span>
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          href="/unpaid-bills"
                          class="list-group-item "
                          target="_blank"
                        >
                          <i class="fa fa-searc report-icon"></i> Unpaid Bills
                          <span class="float-end">Quickbooks</span>
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          href="/vendor-balance-detail"
                          class="list-group-item "
                          target="_blank"
                        >
                          <i class="fa fa-searc report-icon"></i> Vendor Balance
                          Detail
                          <span class="float-end">Quickbooks</span>
                        </a>
                      </div>
                      <div class="list-group col-md-12">
                        <a
                          href="/vendor-balance-summary"
                          class="list-group-item "
                          target="_blank"
                        >
                          <i class="fa fa-searc report-icon"></i> Vendor Balance
                          Summary
                          <span class="float-end">Quickbooks</span>
                        </a>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  {report == 5 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fas fa-wallet mr-2"></i>Expenses and vendors
                      </p>
                      {checkUserPermission("/expense-report") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/expense-report"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i>
                            Expense Report
                            <span class="float-end">PHPPOS</span>
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/customer-contact-list") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/customer-contact-list"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i>1099
                            Transaction Detail Report - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/vendor-contact-list") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/vendor-contact-list"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Check Detail - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}

                      {checkUserPermission("/expenses-by-vendor-summary") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/expenses-by-vendor-summary"
                            target="_blank"
                          >
                            <i class="icon ti-calendar"></i> Expenses by Vendor
                            Summary
                            <span class="float-end">Quickbooks</span>
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/open-purchase-order-list") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/open-purchase-order-list"
                            target="_blank"
                          >
                            <i class="icon ti-calendar"></i> Open Purchase Order
                            List
                            <span class="float-end">Quickbooks</span>
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/open-purchase-order-detail") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/open-purchase-order-detail"
                            target="_blank"
                          >
                            <i class="icon ti-calendar"></i> Open Purchase Order
                            Detail
                            <span class="float-end">Quickbooks</span>
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/employee-contact-list") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/employee-contact-list"
                            target="_blank"
                          >
                            <i class="icon ti-calendar"></i> Purchases by
                            Product/Service Detail - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/employee-contact-list") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/employee-contact-list"
                            target="_blank"
                          >
                            <i class="icon ti-calendar"></i> Purchases by Vendor
                            Detail - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/transaction-list-by-vendor") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/transaction-list-by-vendor"
                            target="_blank"
                          >
                            <i class="icon ti-calendar"></i> Transaction List by
                            Vendor
                            <span class="float-end">Quickbooks</span>
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/vendor-contact-list") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/vendor-contact-list"
                            target="_blank"
                          >
                            <i class="icon ti-calendar"></i> Vendor Contact List
                            <span class="float-end">Quickbooks</span>
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/employee-contact-list") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/employee-contact-list"
                            target="_blank"
                          >
                            <i class="icon ti-calendar"></i> Check Detail - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )}
                  {report == 6 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fa fa-user mr-2"></i>Employees
                      </p>
                      {checkUserPermission("/employee-contact-list") ? (
                        <>
                          <div class="list-group col-md-12">
                            <a
                              class="list-group-item"
                              href="/employee-contact-list"
                              target="_blank"
                            >
                              <i class="icon ti-bar-chart-alt"></i>Employee
                              Contact List
                              <span class="float-end">Quickbooks</span>
                            </a>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/Sale-By-Employee") ? (
                        <>
                          <div class="list-group col-md-12">
                            <a
                              class="list-group-item"
                              href="/Sale-By-Employee"
                              target="_blank"
                            >
                              <i class="icon ti-bar-chart-alt"></i>Sales By
                              Employees
                              <span class="float-end">PHPPOS</span>
                            </a>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/sale-by-employee-summary") ? (
                        <>
                          <div class="list-group col-md-12">
                            <a
                              class="list-group-item"
                              href="/sale-by-employee-summary"
                              target="_blank"
                            >
                              <i class="icon ti-bar-chart-alt"></i>Sales By
                              Employee Summary
                              <span class="float-end">PHPPOS</span>
                            </a>
                          </div>
                        </>
                      ) : (
                        ""
                      )}

                      {checkUserPermission(
                        "/sales-by-customer-summary-report"
                      ) ? (
                        <>
                          <div class="list-group col-md-12">
                            <a
                              class="list-group-item"
                              href="/sales-by-customer-summary-report"
                              target="_blank"
                            >
                              <i class="icon ti-bar-chart-alt"></i>{" "}
                              Recent/Edited Time Activities - NA
                              <span class="float-end">PHP POS</span>
                            </a>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/sales-by-customer-type-detail") ? (
                        <>
                          <div class="list-group col-md-12">
                            <a
                              href="/sales-by-customer-type-detail"
                              class="list-group-item"
                              target="_blank"
                            >
                              {/* <i class="fa fa-calendar"></i> */}
                              Time Activities by Employee Detail - NA
                              <span class="float-end">custom</span>
                            </a>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      {/* <p class="border-bottom mb-4 mt-4 p-lg">
                        <i class="fa fa-user mr-2"></i>Sales By Product/Service
                      </p> */}
                      {/* {checkUserPermission("/sales-by-customer-type-detail") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/sales-by-product-service-detail"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-calendar"></i> Sales by
                            Product/Service Detail
                          </a>
                        </div>
                      ) : (
                        ""
                      )} */}
                      {/* {checkUserPermission(
                        "/sales-by-product-service-summery"
                      ) ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/sales-by-product-service-summery"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-calendar"></i> Sales by
                            Product/Service Summary
                          </a>
                        </div>
                      ) : (
                        ""
                      )} */}
                    </>
                  ) : (
                    ""
                  )}

                  {/* {report==7 ? <>
                    <p class="border-bottom mb-4 p-lg">
                      <i class="fa fa-user"></i> Sales by Customer Type Detail
                    </p>
                    <div class="list-group col-md-12">
                        <a
                          href="/sales-by-customer-type-detail"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="fa fa-calendar"></i> Sales by Customer Type
                          Detail
                        </a>
                      </div>
                   </>: ""}
                   {report==8 ? <>
                    <p class="border-bottom mb-4 p-lg">
                      <i class="fa fa-user mr-2"></i>Sales by Product/Service
                      Detail
                    </p>
                    <div class="list-group col-md-12">
                        <a
                          href="/sales-by-product-service-detail"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-calendar"></i> Sales by
                          Product/Service Detail
                        </a>
                      </div>
                   </>: ""} */}

                  {report == 9 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fas fa-chart-line mr-2"></i> For my accountant
                      </p>
                      {checkUserPermission("/transaction-list-by-date") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/transaction-list-by-date"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-stats-down"></i> Account List - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/transaction-list-by-date") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/transaction-list-by-date"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Transaction List by
                            Date
                            <span class="float-end">Quickbooks</span>
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/transaction-list-by-vendor") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/transaction-list-by-vendor"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-stats-down"></i> Balance Sheet
                            Comparison - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/transaction-list-by-customer") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/transaction-list-by-customer"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Balance Sheet - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/transaction-list-by-customer") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/transaction-list-by-customer"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> General Ledger - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/transaction-list-by-customer") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/transaction-list-by-customer"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Journal - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/transaction-list-by-customer") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/transaction-list-by-customer"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Profit and Loss
                            Comparison - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/transaction-list-by-customer") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/transaction-list-by-customer"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Profit and Loss by
                            Tag Group - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/transaction-list-by-customer") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/transaction-list-by-customer"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Profit and Loss - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/transaction-list-by-customer") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/transaction-list-by-customer"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Recent Transactions
                            - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/transaction-list-by-customer") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/transaction-list-by-customer"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Reconciliation
                            Reports - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/transaction-list-by-customer") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/transaction-list-by-customer"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Recurring Template
                            List - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/transaction-list-by-customer") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/transaction-list-by-customer"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Statement of Cash
                            Flows - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/transaction-list-by-customer") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/transaction-list-by-customer"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Transaction Detail
                            by Account - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}

                      {checkUserPermission("/transaction-list-by-customer") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/transaction-list-by-customer"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Transaction List
                            with Splits - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/trial-balance") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/trial-balance"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Trial Balance
                            <span class="float-end">Quickbooks</span>
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )}
                  {/* {report == 10 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fa fa-search mr-2"></i>Sales by Customer
                        Summary
                      </p>
                      <div class="list-group col-md-12">
                        <a
                          class="list-group-item"
                          href="/sales-by-customer-summary-report"
                          target="_blank"
                        >
                          <i class="icon ti-bar-chart-alt"></i> Sales by
                          Customer Summary
                        </a>
                      </div>
                    </>
                  ) : (
                    ""
                  )} */}
                  {report == 11 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fa fa-credit-card mr-2"></i>Payroll
                      </p>
                      {checkUserPermission("/employee-contact-list") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/employee-contact-list"
                            target="_blank"
                          >
                            <i class="icon ti-calendar"></i>Employee Contact
                            List
                            <span class="float-end">Quickbooks</span>
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/vendor-balance-detail") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/vendor-balance-detail"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i>Recent/Edited Time
                            Activities - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/vendor-balance-detail") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/vendor-balance-detail"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i>Time Activities by
                            Employee Detail - NA
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )}
                  {report == 12 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fad fa-inventory mr-2"></i>Inventory
                      </p>
                      {checkUserPermission("/Inventory-Detailed-Report") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/Inventory-Detailed-Report"
                            target="_blank"
                          >
                            <i class="icon ti-calendar"></i>Inventory Detail
                            Report
                            <span class="float-end">PHPPOS</span>
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/Items-Summary-Report") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/Items-Summary-Report"
                            target="_blank"
                          >
                            <i class="icon ti-calendar"></i>Item Summary Report
                            <span class="float-end">PHPPOS</span>
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )}
                  {/* {report == 12 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fa fa-search mr-2"></i>Expenses by Vendor
                        Summary
                      </p>
                      <div class="list-group col-md-12">
                        <a
                          href="/expenses-by-vendor-summary"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i> Expenses by Vendor
                          Summary
                        </a>
                      </div>
                    </>
                  ) : (
                    ""
                  )} */}

                  {/* {report == 13 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fa fa-search mr-2"></i>Open Purchase Order
                        List
                      </p>
                      {checkUserPermission("/open-purchase-order-detail") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="open-purchase-order-detail"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i>Open Purchase Order
                            Detail
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/open-purchase-order-list") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/open-purchase-order-list"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-stats-down"></i>Open Purchase
                            Order List
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )} */}
                  {/* {report == 14 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fa fa-search mr-2"></i> Income by Customer
                        Summary
                      </p>
                      <div class="list-group col-md-12">
                        <a
                          href="/income-by-customer-summery"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-stats-down"></i>Income by Customer
                          Summary
                        </a>
                      </div>
                    </>
                  ) : (
                    ""
                  )} */}
                  {/* {report == 15 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fa fa-search mr-2"></i>Sales by
                        Product/Service Summary
                      </p>
                      <div class="list-group col-md-12">
                        <a
                          href="/sales-by-product-service-summery"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-bar-chart-alt"></i>Sales by
                          Product/Service Summary
                        </a>
                      </div>
                    </>
                  ) : (
                    ""
                  )} */}
                  {/* {report == 16 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fa fa-search mr-2"></i>Trial Balance
                      </p>
                      <div class="list-group col-md-12">
                        <a
                          href="/trial-balance"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-bar-chart-alt"></i> Trial Balance
                        </a>
                      </div>
                    </>
                  ) : (
                    ""
                  )} */}
                  {/* {report == 17 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fa fa-search mr-2"></i>Balance Sheet
                      </p>
                      {checkUserPermission("/balance-sheet-detail") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/balance-sheet-detail"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i>Balance Sheet Detail
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/balance-sheet-summary") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/balance-sheet-summary"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i>Balance Sheet
                            Summary
                          </a>
                        </div>
                      ) : (
                        ""
                      )}

                      {checkUserPermission("/unpaid-bills") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/unpaid-bills"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-calendar"></i> Unpaid Bills
                          </a>
                        </div>
                      ) : (
                        ""
                      )}

                      {checkUserPermission("/bill-payment-list") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/bill-payment-list"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Bill Payment List
                          </a>
                        </div>
                      ) : (
                        ""
                      )}

                      {checkUserPermission("/bills-applied-payments") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/bills-applied-payments"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-calendar"></i> Bills and Applied
                            Payments
                          </a>
                        </div>
                      ) : (
                        ""
                      )}

                      {checkUserPermission("/profit-and-loss-detail") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/profit-and-loss-detail"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i> Profit and
                            Loss Detail
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission(
                        "/accounts-receivable-aging-detail"
                      ) ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/accounts-receivable-aging-detail"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Accounts receivable
                            aging detail
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission(
                        "/accounts-receivable-aging-summary"
                      ) ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/accounts-receivable-aging-summary"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i>Accounts receivable
                            aging summary
                          </a>
                        </div>
                      ) : (
                        ""
                      )}

                      {checkUserPermission("/accounts-payable-aging-detail") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/accounts-payable-aging-detail"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i> Accounts
                            payable aging detail
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )} */}
                  {/* {report == 18 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fa fa-search mr-2"></i>Profit and Loss
                      </p>
                      <div class="list-group col-md-12">
                        <a
                          href="/profit-and-loss-detail"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-bar-chart-alt"></i> Profit and Loss
                          Detail
                        </a>
                      </div>
                    </>
                  ) : (
                    ""
                  )} */}
                  {/* {report == 19 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fa fa-search mr-2"></i> Accounts Payable
                      </p>
                      {checkUserPermission("/unpaid-bills") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/unpaid-bills"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-calendar"></i> Unpaid Bills
                          </a>
                        </div>
                      ) : (
                        ""
                      )}

                      {checkUserPermission("/bills-applied-payments") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/bills-applied-payments"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-calendar"></i> Bills and Applied
                            Payments
                          </a>
                        </div>
                      ) : (
                        ""
                      )}

                      {checkUserPermission("/bill-payment-list") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/bill-payment-list"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Bill Payment List
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/accounts-payable-aging-detail") ? (
                        <div class="list-group col-md-12">
                          <a
                            href="/accounts-payable-aging-detail"
                            class="list-group-item"
                            target="_blank"
                          >
                            <i class="icon ti-bar-chart-alt"></i> Accounts
                            payable aging detail
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )} */}
                  {/* {report == 20 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fa fa-search mr-2"></i>Accounts Receivable
                      </p>
                      {checkUserPermission(
                        "/accounts-receivable-aging-detail"
                      ) ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/accounts-receivable-aging-detail"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Accounts receivable
                            aging detail
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission(
                        "/accounts-receivable-aging-summary"
                      ) ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/accounts-receivable-aging-summary"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i>Accounts receivable
                            aging summary
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )} */}
                  {/* {report == 21 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fa fa-search mr-2"></i>Item Profit
                      </p>
                      {checkUserPermission(
                        "/item-profit-ability-by-customer"
                      ) ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/item-profit-ability-by-customer"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Item Profit Ability
                            By Customer
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )} */}

                  {/* {report == 22 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fa fa-search mr-2"></i>Categories
                      </p>
                      {checkUserPermission("/sales-by-categories") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/sales-by-categories"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Sales By Categories
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )} */}
                  {/* {report == 23 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fa fa-search mr-2"></i>Deliveries
                      </p>
                      {checkUserPermission("/sale-delivery-list") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/sale-delivery-list"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Detailed Sales
                            Delivery Report
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )} */}
                  {/* {report == 24 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fa fa-search mr-2"></i>Deleted Sales
                      </p>
                      {checkUserPermission("/deleted-sales-report") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/deleted-sales-report"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Deleted Sales Report
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )} */}

                  {/* {report == 25 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fa fa-search mr-2"></i> Employees
                      </p>
                      {checkUserPermission("/Sale-By-Employee") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/Sale-By-Employee"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Detailed Employees
                            Report
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/sale-by-employee-summary") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/sale-by-employee-summary"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Employees Summary
                            Report
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )} */}

                  {/* {report == 26 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fa fa-search mr-2"></i>Inventory
                      </p>
                      {checkUserPermission("/Inventory-Detailed-Report") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/Inventory-Detailed-Report"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Inventory Detailed
                            Report
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/Inventory-Summary-Report") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/Inventory-Summary-Report"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Inventory Summary
                            Report
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )} */}

                  {/* {report == 27 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fa fa-search mr-2"></i>Manufacturer
                      </p>
                      {checkUserPermission("/sale-delivery-list") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/Repots-Manufacturer"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Manufacturers
                            Summary Report
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )} */}

                  {/* {report == 28 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fa fa-search mr-2"></i>Price Rules
                      </p>
                      {checkUserPermission("/Price-Rule-Summary-Report") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/Price-Rule-Summary-Report"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Price Rules Summary
                            Report
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )} */}

                  {/* {report == 29 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fa fa-search mr-2"></i>Receiving
                      </p>
                      {checkUserPermission("/Receiving-List-Report") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/Receiving-List-Report"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Detailed Receivings
                            Report
                          </a>
                        </div>
                      ) : (
                        ""
                      )}

                      <p class="border-bottom mb-4 mt-4 p-lg">
                        <i class="fa fa-search mr-2"></i>Payment
                      </p>
                      {checkUserPermission("/repots-paybill") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/repots-paybill"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Detailed PayBills
                            Report
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )} */}

                  {/* {report == 30 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fa fa-search mr-2"></i>Receive Payments
                      </p>
                      {checkUserPermission("/payment-detail-report") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/payment-detail-report"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Detailed Receive
                            Payments Report
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/payment-summary-report") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/payment-summary-report"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Receive Payments
                            Summary Report
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )} */}
                  {/* {report == 31 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fa fa-search mr-2"></i>Items
                      </p>
                      {checkUserPermission("/items-summary-report") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/items-summary-report"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Items Summary Report
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )} */}

                  {/* {report == 32 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fa fa-search mr-2"></i>PayBill Report Detail
                      </p>
                      {checkUserPermission("/repots-paybill") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/repots-paybill"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> PayBill Report
                            Detail
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )} */}

                  {/* {report == 33 ? (
                    <>
                      <p class="border-bottom mb-4 p-lg">
                        <i class="fa fa-search mr-2"></i> Customers
                      </p>
                      {checkUserPermission(
                        "/detailed-customers-report"
                      ) ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/detailed-customers-report"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Detailed Customers
                            Report
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                      {checkUserPermission("/customer-summary-report") ? (
                        <div class="list-group col-md-12">
                          <a
                            class="list-group-item"
                            href="/customer-summary-report"
                            target="_blank"
                          >
                            <i class="icon ti-receipt"></i> Customers Summary
                            Report
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )} */}
                </div>
              </div>
            </div>
          </div>

          {/* {checkUserPermission('/expense-report') ? (
          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <p class="border-bottom mb-4 p-lg">
                      <i class="fa fa-calendar"></i> Expense Report
                    </p>
                    <div class="row">
                      <div class="list-group col-md-12">
                        <a
                          class="list-group-item"
                          href="/expense-report"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i> Expense Report
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          ) : (
          ""
        )} */}

          {/* {(checkUserPermission('/Customer-Balance-Summary') || checkUserPermission('/customer-balance-detail'))? (
          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <p class="border-bottom mb-4 p-lg">
                      <i class="ti-layout-grid3"></i>Customer Balance Summary
                    </p>
                    <div class="row">
                    {checkUserPermission('/Customer-Balance-Summary') ? (
                      <div class="list-group col-md-6">
                        <a
                          href="/Customer-Balance-Summary"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-bar-chart-alt"></i> Customer Balance
                          Summary
                        </a>
                      </div>
                      ) : (
                        ""
                      )}

                      {checkUserPermission('/Customer-balance-detail') ? ( 
                      <div class="list-group col-md-6">
                        <a
                          href="/customer-balance-detail"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-bar-chart-alt"></i> Customer Balance
                          Detail
                        </a>
                      </div>
                       ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
            ) : (
              ""
            )} */}

          {/* {checkUserPermission('/invoices-and-received-payments') ? ( 
          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <p class="border-bottom mb-4 p-lg">
                      <i class="fa fa-close"></i>Invoices and Received Payments
                    </p>
                    <div class="row">
                      <div class="list-group col-md-12">
                        <a
                          href="/invoices-and-received-payments"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i> Invoices and Received
                          Payments
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
           ) : (
            ""
          )} */}

          {/* {checkUserPermission('/open-invoices') ? ( 
           <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <p class="border-bottom mb-4 p-lg">
                      <i class="fa fa-search"></i>Open Invoices
                    </p>
                    <div class="row">
                      <div class="list-group col-md-12">
                        <a
                          href="/open-invoices"
                          class="list-group-item "
                          target="_blank"
                        >
                          <i class="fa fa-search report-icon"></i> Open Invoices
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
            ) : (
              ""
            )} */}

          {/* {(checkUserPermission('/customer-contact-list') || checkUserPermission('/vendor-contact-list') || checkUserPermission('/employee-contact-list'))? (
          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <p class="border-bottom mb-4 p-lg">
                      <i class="fa fa-search"></i>Contact List
                    </p>
                    <div class="row">
                      {checkUserPermission('/customer-contact-list') ? ( 
                      <div class="list-group col-md-4">
                        <a
                          class="list-group-item"
                          href="/customer-contact-list"
                          target="_blank"
                        >
                          <i class="icon ti-bar-chart-alt"></i>Customer Contact
                          List
                        </a>
                      </div>
                        ) : (
                          ""
                        )}
                      
                      {checkUserPermission('/vendor-contact-list') ? ( 
                       <div class="list-group col-md-4">
                        <a
                          class="list-group-item"
                          href="/vendor-contact-list"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i> Vendor Contact List
                        </a>
                      </div>
                      ) : (
                        ""
                      )}
                      
                      {checkUserPermission('/employee-contact-list') ? ( 

                      <div class="list-group col-md-4">
                        <a
                          class="list-group-item"
                          href="/employee-contact-list"
                          target="_blank"
                        >
                          <i class="icon ti-calendar"></i> Employee Contact List
                        </a>
                      </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          ) : (
            ""
          )}
         */}
          {/* {checkUserPermission('/sales-by-customer-detail') ? ( 
          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <p class="border-bottom mb-4 p-lg">
                      <i class="fa fa-user"></i>Sales by Customer Detail
                    </p>
                    <div class="row">
                      <div class="list-group col-md-12">
                        <a
                          class="list-group-item"
                          href="/sales-by-customer-detail"
                          target="_blank"
                        >
                          <i class="icon ti-bar-chart-alt"></i> Sales by
                          Customer Detail
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          ) : (
            ""
          )} */}

          {/* {checkUserPermission('/sales-by-customer-type-detail') ? ( 
          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <p class="border-bottom mb-4 p-lg">
                      <i class="fa fa-delete"></i> Sales by Customer Type Detail
                    </p>
                    <div class="row">
                      <div class="list-group col-md-12">
                        <a
                          href="/sales-by-customer-type-detail"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="fa fa-calendar"></i> Sales by Customer Type
                          Detail
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )} */}

          {/* {checkUserPermission('/sales-by-product-service-detail') ? (
          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <p class="border-bottom mb-4 p-lg">
                      <i class="fa fa-delete"></i>Sales by Product/Service
                      Detail
                    </p>
                    <div class="row">
                      <div class="list-group col-md-12">
                        <a
                          href="/sales-by-product-service-detail"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-calendar"></i> Sales by
                          Product/Service Detail
                        </a>
                      </div>


                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          ) : (
            ""
            )} */}

          {/* {(checkUserPermission('/transaction-list-by-customer') || checkUserPermission('/transaction-list-by-vendor') || checkUserPermission('/transaction-list-by-date'))? (
           <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <p class="border-bottom mb-4 p-lg">
                      <i class="fa fa-delete"></i> Transaction List
                    </p>
                    <div class="row">
                     {checkUserPermission('/transaction-list-by-customer') ? (
                       <div class="list-group col-md-4">

                        <a
                          href="/transaction-list-by-customer"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i> Transaction List by
                          Customer
                        </a>
                      </div>
                       ) : (
                        ""
                        )}

                     {checkUserPermission('/transaction-list-by-vendor') ? (
                       <div class="list-group col-md-4">
                      
                        <a
                          href="/transaction-list-by-vendor"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-stats-down"></i> Transaction List by
                          Vendor
                        </a>
                      </div>
                         ) : (
                          ""
                          )}
                     {checkUserPermission('/transaction-list-by-date') ? (
                       <div class="list-group col-md-4">
                         <a
                          href="/transaction-list-by-date"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-stats-down"></i> Transaction List by
                          Date
                        </a>
                      </div>
                       ) : (
                        ""
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
          )} */}

          {/* {checkUserPermission('/sales-by-customer-summary-report') ? (
            <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <p class="border-bottom mb-4 p-lg">
                      <i class="fa fa-search"></i>Sales by Customer Summary
                    </p>
                    <div class="row">
                      <div class="list-group col-md-12">
                        <a
                          class="list-group-item"
                          href="/sales-by-customer-summary-report"
                          target="_blank"
                        >
                          <i class="icon ti-bar-chart-alt"></i> Sales by
                          Customer Summary
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          ) : (
            ""
            )} */}
          {/* 
           {(checkUserPermission('/vendor-balance-detail') ||  checkUserPermission('/vendor-balance-summary')) ?(
          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <p class="border-bottom mb-4 p-lg">
                      <i class="fa fa-search"></i>Vendor Balance
                    </p>
                    <div class="row">
                      {checkUserPermission('/vendor-balance-detail') ? (
                      <div class="list-group col-md-6">
                        <a
                          class="list-group-item"
                          href="/vendor-balance-detail"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i>Vendor Balance Detail
                        </a>
                      </div>
                      ) : (
                        ""
                        )}

                    {checkUserPermission('/vendor-balance-summary') ? (
                      <div class="list-group col-md-6">
                        <a
                          class="list-group-item"
                          href="/vendor-balance-summary"
                          target="_blank"
                        >
                          <i class="icon ti-calendar"></i>Vendor Balance Summary
                        </a>
                      </div>
                       ) : (
                        ""
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
           ) : (
            ""
            )} */}

          {/* {checkUserPermission('/expenses-by-vendor-summary') ? (
          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <p class="border-bottom mb-4 p-lg">
                      <i class="fa fa-search"></i>Expenses by Vendor Summary
                    </p>
                    <div class="row">
                      <div class="list-group col-md-12">
                        <a
                          href="/expenses-by-vendor-summary"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i> Expenses by Vendor
                          Summary
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
           ) : (
            ""
            )} */}

          {/* {(checkUserPermission('/open-purchase-order-list') || checkUserPermission('/open-purchase-order-detail'))? (
           <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <p class="border-bottom mb-4 p-lg">
                      <i class="fa fa-search"></i>Open Purchase Order List
                    </p>
                    <div class="row">
                      {checkUserPermission('/open-purchase-order-list') ? (
                       <div class="list-group col-md-6">
                        <a
                          href="/open-purchase-order-list"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-stats-down"></i>Open Purchase Order
                          List
                        </a>
                      </div>
                       ) : (
                        ""
                        )}

                    {checkUserPermission('/open-purchase-order-detail') ? (
                      <div class="list-group col-md-6">
                        <a
                          href="open-purchase-order-detail"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i>Open Purchase Order
                          Detail
                        </a>
                      </div>
                      ) : (
                        ""
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          ) : (
            ""
            )} */}

          {/* {checkUserPermission('/income-by-customer-summery') ? (
          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <p class="border-bottom mb-4 p-lg">
                      <i class="fa fa-search"></i> Income by Customer Summary
                    </p>
                    <div class="row">
                      <div class="list-group col-md-12">
                        <a
                          href="/income-by-customer-summery"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-stats-down"></i>Income by Customer
                          Summary
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
         ) : (
          ""
          )} */}

          {/* {checkUserPermission('/sales-by-product-service-summery') ? (
          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <p class="border-bottom mb-4 p-lg">
                      <i class="fa fa-search"></i>Sales by Product/Service
                      Summary
                    </p>
                    <div class="row">
                      <div class="list-group col-md-12">
                        <a
                          href="/sales-by-product-service-summery"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-bar-chart-alt"></i>Sales by
                          Product/Service Summary
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
          )} */}

          {/* {checkUserPermission('/trial-balance') ? (
           <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <p class="border-bottom mb-4 p-lg">
                      <i class="fa fa-search"></i>Trial Balance
                    </p>
                    <div class="row">
                      <div class="list-group col-md-12">
                        <a
                          href="/trial-balance"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-bar-chart-alt"></i> Trial Balance
                        </a>
                      </div>

                    </div>


                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
          )} */}

          {/* {(checkUserPermission('/balance-sheet-summary') || checkUserPermission('/balance-sheet-detail')) ? (
         <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <p class="border-bottom mb-4 p-lg">
                      <i class="fa fa-search"></i>Balance Sheet
                    </p>
                    <div class="row">
                     {checkUserPermission('/balance-sheet-summary') ? (
                       <div class="list-group col-md-6">
                        <a
                          href="/balance-sheet-summary"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-bar-chart-alt"></i>Balance Sheet Summary
                        </a>
                      </div>
                      ) : (
                        ""
                        )}

                     {checkUserPermission('/balance-sheet-detail') ? (
                       <div class="list-group col-md-6">
                        <a
                          href="/balance-sheet-detail"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i>Balance Sheet Detail
                        </a>
                      </div>
                       ) : (
                        ""
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
        ""
        )} */}

          {/* {checkUserPermission('/profit-and-loss-detail') ? (
          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <p class="border-bottom mb-4 p-lg">
                      <i class="fa fa-search"></i>Profit and Loss
                    </p>
                    <div class="row">
                      <div class="list-group col-md-12">
                        <a
                          href="/profit-and-loss-detail"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-bar-chart-alt"></i>  Profit and Loss Detail
                        </a>
                      </div>
                     
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          ) : (
            ""
            )} */}

          {/* {((checkUserPermission('/accounts-payable-aging-detail') || checkUserPermission('/accounts-payable-aging-summary') || checkUserPermission('/bill-payment-list')) || checkUserPermission('/bills-applied-payments') || checkUserPermission('/unpaid-bills'))? (
           <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <p class="border-bottom mb-4 p-lg">
                      <i class="fa fa-search"></i> Accounts Payable
                    </p>
                    <div class="row">
                    {checkUserPermission('/accounts-payable-aging-detail') ? (
                      <div class="list-group col-md-6">
                        <a
                          href="/accounts-payable-aging-detail"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-bar-chart-alt"></i> Accounts payable aging detail
                        </a>
                      </div>
                         ) : (
                          ""
                          )}
                   
                    {checkUserPermission('/bill-payment-list') ? (

                    <div class="list-group col-md-6">
                      <a
                        href="/bill-payment-list"
                        class="list-group-item"
                        target="_blank"
                      >
                        <i class="icon ti-receipt"></i> Bill Payment List
                      </a>
                    </div>
                    ) : (
                    ""
                    )}

                    </div>
                    <div class="row mt-3">

                    {checkUserPermission('/bills-applied-payments') ? (
                      
                      <div class="list-group col-md-6">
                        <a
                          href="/bills-applied-payments"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-calendar"></i> Bills and Applied Payments
                        </a>
                      </div>
                       ) : (
                        ""
                        )}

                    {checkUserPermission('/unpaid-bills') ? (
                      <div class="list-group col-md-6">
                        <a
                          href="/unpaid-bills"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-calendar"></i> Unpaid Bills
                        </a>
                      </div>
                       ) : (
                        ""
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
           ) : (
            ""
            )}
           */}
          {/* {(checkUserPermission('/accounts-receivable-aging-summary') || checkUserPermission('/accounts-receivable-aging-detail')) ? (

          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <p class="border-bottom mb-4 p-lg">
                      <i class="fa fa-search"></i>Accounts Receivable
                    </p>
                    <div class="row">
                    {checkUserPermission('/accounts-receivable-aging-summary') ? (

                      <div class="list-group col-md-6">
                        <a
                          class="list-group-item"
                          href="/accounts-receivable-aging-summary"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i>Accounts receivable aging summary
                        </a>
                      </div>
                        ) : (
                          ""
                          )}

                    {checkUserPermission('/accounts-receivable-aging-detail') ? (
                       <div class="list-group col-md-6">
                        <a
                          class="list-group-item"
                          href="/accounts-receivable-aging-detail"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i> Accounts receivable aging detail
                        </a>
                      </div>
                       ) : (
                        ""
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          ) : (
            ""
            )} */}

          {/*  <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-search"></i>Profit and Loss
                    </h4>
                    <div class="row">
                      <div class="list-group col-md-6">
                        <a
                          class="list-group-item"
                          href="https://demo.phppointofsale.com/index.php/reports/generate/summary_profit_and_loss"
                        >
                          <i class="icon ti-receipt"></i> Summary Reports
                        </a>
                      </div>
                      <div class="list-group col-md-6">
                        <a
                          class="list-group-item"
                          href="https://demo.phppointofsale.com/index.php/reports/generate/detailed_profit_and_loss"
                        >
                          <i class="icon ti-calendar"></i> Detailed Reports
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-search"></i>Registers
                    </h4>
                    <div class="row">
                      <div class="list-group col-md-6">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/summary_registers"
                          class="list-group-item"
                        >
                          <i class="icon ti-calendar"></i> Summary Reports
                        </a>
                      </div>
                      <div class="list-group col-md-6">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/graphical_summary_registers"
                          class="list-group-item"
                        >
                          <i class="icon ti-bar-chart-alt"></i> Graphical
                          Reports
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-search"></i>Sales
                    </h4>
                    <div class="row">
                      <div class="list-group col-md-4">
                        <a
                          class="list-group-item"
                          href="https://demo.phppointofsale.com/index.php/reports/generate/summary_journal"
                        >
                          <i class="icon ti-receipt"></i> Summary Journal report
                        </a>
                      </div>
                      <div class="list-group col-md-4">
                        <a
                          class="list-group-item"
                          href="https://demo.phppointofsale.com/index.php/reports/generate/graphical_summary_sales"
                        >
                          <i class="icon ti-bar-chart-alt"></i> Graphical
                          Reports
                        </a>
                      </div>
                      <div class="list-group col-md-4">
                        <a
                          class="list-group-item"
                          href="https://demo.phppointofsale.com/index.php/reports/generate/summary_sales"
                        >
                          <i class="icon ti-receipt"></i> Summary Reports
                        </a>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="list-group col-md-4">
                        <a
                          class="list-group-item"
                          href="https://demo.phppointofsale.com/index.php/reports/generate/detailed_sales"
                        >
                          <i class="icon ti-calendar"></i> Detailed Reports
                        </a>
                      </div>
                      <div class="list-group col-md-4">
                        <a
                          class="list-group-item"
                          href="https://demo.phppointofsale.com/index.php/reports/generate/summary_sales_day_of_week"
                        >
                          <i class="icon ti-receipt"></i> Day of Week Report
                        </a>
                      </div>
                      <div class="list-group col-md-4">
                        <a
                          class="list-group-item"
                          href="https://demo.phppointofsale.com/index.php/reports/generate/detailed_ecommerce_sales"
                        >
                          <i class="icon ti-calendar"></i> E-Commerce
                        </a>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="list-group col-md-4">
                        <a
                          class="list-group-item"
                          href="https://demo.phppointofsale.com/index.php/reports/generate/summary_sales_locations"
                        >
                          <i class="icon ti-receipt"></i> Locations
                        </a>
                      </div>
                      <div class="list-group col-md-4">
                        <a
                          class="list-group-item"
                          href="https://demo.phppointofsale.com/index.php/reports/generate/summary_tips"
                        >
                          <i class="ion-cash"></i> Tips
                        </a>
                      </div>
                      <div class="list-group col-md-4">
                        <a
                          class="list-group-item"
                          href="https://demo.phppointofsale.com/index.php/reports/generate/detailed_last_4_cc"
                        >
                          <i class="icon ti-calendar"></i> Last 4 of Credit Card
                        </a>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="list-group col-md-6">
                        <a
                          class="list-group-item"
                          href="https://demo.phppointofsale.com/index.php/reports/generate/summary_sales_time"
                        >
                          <i class="icon ti-receipt"></i> Summary Sales by Time
                          Reports
                        </a>
                      </div>
                      <div class="list-group col-md-6">
                        <a
                          class="list-group-item"
                          href="https://demo.phppointofsale.com/index.php/reports/generate/graphical_summary_sales_time"
                        >
                          <i class="icon ti-bar-chart-alt"></i> Graphical
                          Summary Sales by Time Reports
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-search"></i>Receiving
                    </h4>
                    <div class="row">
                      <div class="list-group col-md-4">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/summary_categories_receivings"
                          class="list-group-item"
                        >
                          <i class="icon ti-receipt"></i> Summary Categories
                        </a>
                      </div>
                      <div class="list-group col-md-4">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/transfers"
                          class="list-group-item"
                        >
                          <i class="icon ti-calendar"></i> Transfers
                        </a>
                      </div>
                      <div class="list-group col-md-4">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/detailed_receivings"
                          class="list-group-item"
                        >
                          <i class="icon ti-calendar"></i> Detailed Reports
                        </a>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="list-group col-md-4">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/detailed_suspended_receivings"
                          class="list-group-item"
                        >
                          <i class="icon ti-calendar"></i> Suspended Receivings
                        </a>
                      </div>
                      <div class="list-group col-md-4">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/deleted_receivings"
                          class="list-group-item"
                        >
                          <i class="icon ti-receipt"></i> Deleted Receivings
                          Report
                        </a>
                      </div>
                      <div class="list-group col-md-4">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/summary_taxes_receivings"
                          class="list-group-item"
                        >
                          <i class="icon ti-receipt"></i> Summary taxes report
                        </a>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="list-group col-md-4">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/graphical_summary_taxes_receivings"
                          class="list-group-item"
                        >
                          <i class="icon ti-bar-chart-alt"></i> Graphical
                          summary taxes report
                        </a>
                      </div>
                      <div class="list-group col-md-4">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/cheapest_supplier"
                          class="list-group-item"
                        >
                          <i class="icon ti-download"></i> Cheapest Supplier
                        </a>
                      </div>
                    </div>
                    <br />
                    <h4 class="text-info">Items</h4>
                    <div class="row mt-3">
                      <div class="list-group col-md-6">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/graphical_summary_items_receivings"
                          class="list-group-item"
                        >
                          <i class="ti-bar-chart-alt"></i> Graphical Reports
                        </a>
                      </div>
                      <div class="list-group col-md-6">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/summary_items_receivings"
                          class="list-group-item"
                        >
                          <i class="icon ti-receipt"></i> Summary Reports
                        </a>
                      </div>
                    </div>
                    <br />
                    <h4 class="text-info">Payments</h4>
                    <div class="row mt-3">
                      <div class="list-group col-md-4">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/receivings_graphical_summary_payments"
                          class="list-group-item"
                        >
                          <i class="icon ti-bar-chart-alt"></i> Graphical
                          Reports
                        </a>
                      </div>
                      <div class="list-group col-md-4">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/receivings_summary_payments"
                          class="list-group-item text-warning"
                        >
                          <i class="icon ti-receipt"></i> Summary Reports
                        </a>
                      </div>
                      <div class="list-group col-md-4">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/receivings_detailed_payments"
                          class="list-group-item"
                        >
                          <i class="icon ti-calendar"></i> Detailed Reports
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-search"></i>Suspended Sales
                    </h4>
                    <div class="row">
                      <div class="list-group col-md-6">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/detailed_suspended_sales"
                          class="list-group-item"
                        >
                          <i class="icon ti-calendar"></i> Detailed Reports
                        </a>
                      </div>
                      <div class="list-group col-md-6">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/layaway_statements"
                          class="list-group-item"
                        >
                          <i class="icon ti-receipt"></i> Layaway Statements
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-search"></i>Tags
                    </h4>
                    <div class="row">
                      <div class="list-group col-md-6">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/graphical_summary_tags"
                          class="list-group-item"
                        >
                          <i class="icon ti-bar-chart-alt"></i> Graphical
                          Reports
                        </a>
                      </div>
                      <div class="list-group col-md-6">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/summary_tags"
                          class="list-group-item"
                        >
                          <i class="icon ti-receipt"></i> Summary Reports
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-search"></i>Taxes
                    </h4>
                    <div class="row">
                      <div class="list-group col-md-6">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/graphical_summary_taxes"
                          class="list-group-item"
                        >
                          <i class="icon ti-bar-chart-alt"></i> Graphical
                          Reports
                        </a>
                      </div>
                      <div class="list-group col-md-6">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/summary_taxes"
                          class="list-group-item"
                        >
                          <i class="icon ti-receipt"></i> Summary Reports
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
{/*  */}
          {/* <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-search"></i>Tiers
                    </h4>
                    <div class="row">
                      <div class="list-group">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/summary_tiers"
                          class="list-group-item"
                        >
                          <i class="icon ti-receipt"></i> Summary Reports
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>  */}
        </div>
      </div>
    </>
  );
};

export default ReportList;
